var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.groups, function (group, pIdx) {
      return _c(
        "div",
        {
          key: pIdx,
          staticClass: "card accordion",
          attrs: { id: `accordion_${pIdx}` },
        },
        [
          _c("div", { staticClass: "card-header" }, [
            _c("div", { staticClass: "row no-gutters" }, [
              _c(
                "div",
                {
                  staticClass: "col",
                  attrs: {
                    "data-toggle": "collapse",
                    id: `heading_${group.id}_${pIdx}`,
                    "data-target": `#collapse_${group.id}_${pIdx}`,
                    "aria-controls": `collapse_${group.id}-${pIdx}`,
                  },
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(group.name) +
                      "\n                "
                  ),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "collapse",
              attrs: {
                id: `collapse_${group.id}_${pIdx}`,
                "aria-labelledby": `heading_${group.id}_${pIdx}`,
              },
            },
            [
              _c(
                "div",
                { staticClass: "card-body" },
                _vm._l(group.kinds, function (child, cIdx) {
                  return _c(
                    "div",
                    {
                      key: `accordion_${group.id}_${cIdx}`,
                      staticClass: "card accordion",
                      class: {
                        "mt-3": cIdx == 0,
                        "mb-3":
                          group.kinds.length == 0 ||
                          cIdx == group.kinds.length - 1,
                      },
                    },
                    [
                      _c("div", { staticClass: "card-header" }, [
                        _c("div", { staticClass: "row no-gutters" }, [
                          _c(
                            "div",
                            {
                              staticClass: "col",
                              attrs: {
                                "data-toggle": "collapse",
                                id: `heading_child_${child.id}_${cIdx}`,
                                "data-target": `#collapse_child_${child.id}_${cIdx}`,
                                "aria-controls": `collapse_child_${child.id}-${cIdx}`,
                              },
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(child.name) +
                                  "\n                            "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "collapse",
                          attrs: {
                            id: `collapse_child_${child.id}_${cIdx}`,
                            "aria-labelledby": `heading_child_${child.id}_${cIdx}`,
                          },
                        },
                        [
                          _c("div", { staticClass: "card-body" }, [
                            _c(
                              "div",
                              { staticClass: "card-body py-3" },
                              _vm._l(child.types, function (typeItem) {
                                return _c(
                                  "div",
                                  {
                                    key: `type-${typeItem.id}`,
                                    staticClass:
                                      "form-check city-form-check px-0 px-sm-2 mb-1",
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.mutableValue,
                                          expression: "mutableValue",
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                        },
                                      ],
                                      staticClass: "form-check-input",
                                      attrs: {
                                        type: "checkbox",
                                        disabled: _vm.readonlyFormItem,
                                        id: `checktype_${typeItem.id}`,
                                        name: `checktype_${typeItem.id}`,
                                      },
                                      domProps: {
                                        value: { id: typeItem.id },
                                        checked: Array.isArray(_vm.mutableValue)
                                          ? _vm._i(_vm.mutableValue, {
                                              id: typeItem.id,
                                            }) > -1
                                          : _vm.mutableValue,
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$a = _vm.mutableValue,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = { id: typeItem.id },
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.mutableValue = $$a.concat([
                                                  $$v,
                                                ]))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.mutableValue = $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.mutableValue = $$c
                                          }
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "form-check-label",
                                        attrs: {
                                          for: `checktype_${typeItem.id}`,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(typeItem.name) +
                                            "\n                                    "
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              }),
                              0
                            ),
                          ]),
                        ]
                      ),
                    ]
                  )
                }),
                0
              ),
            ]
          ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }